import moment from 'moment';
import XLSX from 'sheetjs-style';
import { DetenteurEntity } from '../../../../entities/detenteur.entity';
import { SECONDARY } from '../../../../shared/colors';

export const generateDetenteurDataToExport = (detenteurs: any[]) => {
  let toExport: any[] = [];
  let index = 1;
  for (let det of detenteurs) {
    toExport.push({
      Index: index,
      'Code client': det.code_referent,
      Nom: det.nom,
      Prénom: det.prenom,
      Email: det.email,
      Adresse: det.adresse,
      Nationalité: det.nationalite,
      Téléphone: det.mobile,
      Gestionnaire: `${det.createur.nom} ${det.createur.prenom}`,
      'Qte total titre': det.qteTotal,
      'Montant total': det.montantTotal,
      'P&L': det.pnl,
      'Code agence': det.agence.code,
      Agence: det.agence.nom,
      'Code partenaire': det.partenaire.code_referent,
      Partenaire: det.partenaire.nom,
      'Date création': `${moment(det.created_at).format(
        'DD/MM/YYYY HH:mm:ss',
      )}`,
      'Date modification': `${moment(det.updated_at).format(
        'DD/MM/YYYY HH:mm:ss',
      )}`,
    });
    index += 1;
  }

  return toExport;
};

export const generateBondDetailDataToExport = (detenteurs: any[]) => {
  let toExport: any[] = [];
  let index = 1;
  for (let det of detenteurs) {
    for (let detB of det.detailBonds) {
      toExport.push({
        Index: index,
        Code: detB.parentCode,
        'Sous code': detB.subCode,
        Emetteur: detB.bond.pays,
        Instrument: detB.bond.instrument,
        'Date Emission': detB.bond.dateEmission,
        'Date Maturite': detB.bond.dateMaturite,
        'Duree Maturite': detB.bond.dureeMaturite,
        Etat: detB.etat,
        Quantite: detB.qte,
        'Montant total': detB.montant,
        Prix: detB.prixNominale,
        'Décote (%)': detB.decote,
        'Coupon (%)': detB.bond.tauxMarginal,
        'Rendement (%)': detB.tauxRendement,
        'P&L': detB.pnl,
        'Code origin': detB.originCode,
        'Code client': detB.detenteur.code_referent,
        'Nom client': detB.detenteur.nom + ' ' + detB.detenteur.prenom,
        'Date acquisition': `${moment(detB.dateAcquisition).format(
          'DD/MM/YYYY',
        )}`,
        'Coupon Couru à Payer': detB.couponCouruPayer,
        'Coupon à Percevoir': detB.couponPercevoir,
        'Commission Total': detB.commissionTotal,
      });
      index += 1;
    }
  }

  return toExport;
};

const countColumns = (data: any[]) => {
  let firstLine = data[0];
  return Object.keys(firstLine).length;
};

export const exportPortefeuilleData = (detenteurs: DetenteurEntity[]) => {
  let wb = XLSX.utils.book_new();
  const detenteurData = generateDetenteurDataToExport(detenteurs);
  const bondDetailsData = generateBondDetailDataToExport(detenteurs);
  let ws1 = XLSX.utils.json_to_sheet(detenteurData);
  let ws2 = XLSX.utils.json_to_sheet(bondDetailsData);

  // style cells
  let numberCols = countColumns(detenteurData);
  for (let i = 0; i < numberCols; i++) {
    // style table header
    ws1[`${String.fromCharCode(65 + i)}1`].s = {
      font: {
        name: 'Poppins-B',
        sz: 10,
        color: { rgb: 'FFFFFF' },
      },
      fill: {
        bgColor: SECONDARY,
      },
      border: {
        top: { style: 'thin', color: { rgb: 'FFFFFF' } },
        bottom: { style: 'thin', color: { rgb: 'FFFFFF' } },
        left: { style: 'thin', color: { rgb: 'FFFFFF' } },
        right: { style: 'thin', color: { rgb: 'FFFFFF' } },
      },
    };
    // style content of table
    for (let j = 2; j <= detenteurData.length + 1; j++) {
      ws1[`${String.fromCharCode(65 + i)}${j}`].s = {
        font: {
          name: 'Poppins-L',
          sz: 10,
        },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        },
      };
    }
  }
  numberCols = countColumns(bondDetailsData);
  for (let i = 0; i < numberCols; i++) {
    // style table header
    ws2[`${String.fromCharCode(65 + i)}1`].s = {
      font: {
        name: 'Poppins-B',
        sz: 10,
        color: { rgb: 'FFFFFF' },
      },
      fill: {
        bgColor: SECONDARY,
      },
      border: {
        top: { style: 'thin', color: { rgb: 'FFFFFF' } },
        bottom: { style: 'thin', color: { rgb: 'FFFFFF' } },
        left: { style: 'thin', color: { rgb: 'FFFFFF' } },
        right: { style: 'thin', color: { rgb: 'FFFFFF' } },
      },
    };
    // style content of table
    for (let j = 2; j <= bondDetailsData.length + 1; j++) {
      ws2[`${String.fromCharCode(65 + i)}${j}`].s = {
        font: {
          name: 'Poppins-L',
          sz: 10,
        },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        },
      };
    }
  }

  XLSX.utils.book_append_sheet(wb, ws1, 'Etat des détenteurs');
  XLSX.utils.book_append_sheet(wb, ws2, 'Etat détailé du portefeuille');
  XLSX.writeFile(
    wb,
    `Portefeuille - ${moment(new Date()).format('DD/MM/YYYY')}.xlsx`,
  );
};
